import { render, staticRenderFns } from "./NewMainLeftMenu.vue?vue&type=template&id=cdbff424&"
import script from "./NewMainLeftMenu.vue?vue&type=script&lang=js&"
export * from "./NewMainLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewMainLeftMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbff424')) {
      api.createRecord('cdbff424', component.options)
    } else {
      api.reload('cdbff424', component.options)
    }
    module.hot.accept("./NewMainLeftMenu.vue?vue&type=template&id=cdbff424&", function () {
      api.rerender('cdbff424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/NewMainLeftMenu.vue"
export default component.exports